import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetNotificationsResponse, GetNotificationsParams } from "../../api/notification";
import tokenNotFound from "./config/tokenNotFound";

export type TApiNGWordsResult = {
  result?: GetNotificationsResponse;
};

export const fetchNotifications = async (params: GetNotificationsParams): Promise<TApiResult & TApiNGWordsResult> => {
  const query = {
    query :  {...params }
  }; 
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .notifications.get({...query,...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchNotifications");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
